export default "__VITE_ASSET__LSQ3r3Du__"